import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Button } from 'antd';

const BackRoute = ({ route, ...otherProps }) => {
  const history = useHistory();
  const handleGoBack = useCallback(
    () =>
      history.action !== 'POP' ? history.goBack() : history.replace(route),
    [history, route]
  );
  return <Button {...otherProps} onClick={handleGoBack} />;
};
BackRoute.propTypes = {
  route: PropTypes.object.isRequired,
};

export default BackRoute;
